const facts = [
  { k: "Background", v: "Seven years in accounting and finance" },
  { k: "Building since", v: "2021" },
  { k: "Focus", v: "Close, document chase, reconciliation" },
  { k: "Engagement", v: "Fixed scope, or monthly care" },
];

export default function About() {
  return (
    <section id="about" className="t-sec t-sec--alt" aria-labelledby="about-title">
      <div className="t-wrap t-about__grid">
        <figure className="t-rise">
          <img
            className="t-photo t-about__photo"
            src="/profile.jpg"
            alt="Rafael, the engineer behind Firechain"
            width={1000}
            height={1000}
            loading="lazy"
            decoding="async"
          />
          <figcaption className="t-caption">Rafael — Firechain</figcaption>
        </figure>

        <div>
          <h2 id="about-title" className="t-h2 t-rise">
            From the books to the build.
          </h2>
          <p className="t-body t-para t-rise">
            I spent seven years in accounting and finance before I moved into software. I have
            prepared the close, chased the statements, and rebuilt the spreadsheet the night before
            a review. Now I build the systems that stop that from happening.
          </p>
          <p className="t-body t-para t-rise">
            One person, start to finish. I scope it, build it, and hand it over documented well
            enough that your team can run it without me.
          </p>

          <dl className="t-facts t-rise">
            {facts.map((fact) => (
              <div key={fact.k}>
                <dt className="t-fact__k">{fact.k}</dt>
                <dd className="t-fact__v">{fact.v}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}
